// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackCopyWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackCopyWishList = (parameters: TrackCopyWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "copy_wishlist", ...parameters }, options);
};

export default trackCopyWishList;
